import { ContentHeader } from "../../components";
import { Form, Button, Input, Row, Col, Table, Space } from 'antd';
import { DeleteOutlined, SaveOutlined, EditOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { useEffect, useState } from "react";
import Column from 'antd/es/table/Column';
import { ChucVuDang } from "../../models/danhmuc/DanhMuc";
import { layDanhMucChucVuDang,luuChucVuDang, xoaChucVuDang } from "@app/services/danhmuc";
import ModalTextForm from "@app/components/modal/ModalTextForm";
import { toast } from "react-toastify";
import { validateMessages } from '../../helpers/common';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import { useDispatch } from 'react-redux';
import { searchLength } from "../../constants";

const QuanLyChucVuDang = () => {
    const [data, setData] = useState<Array<ChucVuDang>>([]);
    const [tuKhoa, setTuKhoa] = useState<string>("");
    const [page, setPage] = useState(1);
    const [reloadPage, setReloadPage] = useState<boolean>(true);
    const [isLoadingTable, setIsLoadingTable] = useState<boolean>(false);
    const [isLoadingBtn, setIsLoadingBtn] = useState<boolean>(false);
    const [showModalChiTiet, setShowModalChiTiet] = useState<boolean>(false);
    const [idXoa, setIdXoa] = useState<number>(0);
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const setFormDetailModal = (value: ChucVuDang | null) => {
        form.setFieldsValue({
            "id": value?.id || 0,
            "ma": value?.ma || "",
            "ten": value?.ten || ""
        });
        setShowModalChiTiet(true);
    }

    const layDuLieu = async () => {
        try {
            setIsLoadingTable(true);
            let rs = await layDanhMucChucVuDang();
            setData(rs);
            setIsLoadingTable(false);
        } catch (error: any) {
            setIsLoadingTable(false);
        };
    }

    const onDelete = async () => {
        try {
            setIsLoadingBtn(true);
            await xoaChucVuDang(idXoa);
            toast.success('Xoá chức vụ Đảng thành công!');

            // Tính toán số trang mới sau khi xóa
            const totalRecords = data.length - 1; // Số lượng bản ghi sau khi xóa
            let newPage = page;

            if (newPage > Math.ceil(totalRecords / searchLength)) {
                // Nếu trang hiện tại lớn hơn số trang mới tối đa
                newPage = Math.ceil(totalRecords / searchLength);
            }

            setPage(newPage);
        }
        catch (err: any) {
            toast.error('Đã xảy ra lỗi, xoá không thành công!');
        }
        setIdXoa(0);
        setReloadPage(true);
        setIsLoadingBtn(false);
    }

    const onFinish = async (values: any) => {
        try {
            dispatch(showLoadingScreen());
            setIsLoadingBtn(true);
            await luuChucVuDang(values);
            setShowModalChiTiet(false);
            toast.success('Lưu thông tin chức vụ Đảng thành công!')
        }
        catch (err: any) {
            setShowModalChiTiet(false);
            toast.error('Đã xảy ra lỗi, lưu không thành công!');
        }
        dispatch(hideLoadingScreen());
        setIsLoadingBtn(false);
        setReloadPage(true);
    };

    useEffect(() => {
        if (reloadPage) {
            layDuLieu();
            setReloadPage(false);
        }
    }, [reloadPage]);

    return (<section>
        <ContentHeader title="Quản lý danh mục chức vụ Đảng" />
        {idXoa > 0 && <ModalTextForm show={idXoa > 0}
            title="Xoá chức vụ Đảng"
            handleClose={() => setIdXoa(0)}
            handleSave={onDelete}>
            Xác nhận xóa chức vụ Đảng đang chọn
        </ModalTextForm>}
        {showModalChiTiet && <ModalTextForm title="Quản lý chức vụ Đảng"
            hideFooter
            show={showModalChiTiet}
            handleClose={() => setShowModalChiTiet(false)}
        >
            <Form
                layout="vertical"
                validateMessages={validateMessages}
                onFinish={onFinish}
                form={form}
            >
                <Form.Item hidden name="id"><Input /></Form.Item>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            label="Mã chức vụ Đảng"
                            name="ma" >
                            <Input placeholder="Mã chức vụ Đảng" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Tên chức vụ Đảng"
                            name="ten"
                            rules={[{ required: true, message: 'Vui lòng nhập tên chức vụ' }]}
                        >
                            <Input placeholder="Tên chức vụ Đảng"/>
                        </Form.Item>
                    </Col>
                </Row>
                <Form.Item>
                    <Button type="primary" loading={isLoadingBtn} className="float-right" htmlType="submit" icon=<SaveOutlined rev="" />>
                        Lưu
                    </Button>
                </Form.Item>
            </Form>
        </ModalTextForm>}
        <Row className="form-group" gutter={8}>
            <Col span={8}>
                <Input prefix={<SearchOutlined rev="" />} placeholder="Nhập tên chức vụ Đảng để tìm kiếm" onChange={(e) => {setPage(1); setTuKhoa(e.target.value)}} />
            </Col>
            <Col span={16}>
                <Button
                    className="hrm-btn hrm-btn-warning float-right"
                    onClick={() => {
                        setFormDetailModal(null);
                    }}
                    icon={<PlusOutlined rev="" />}
                >
                    Thêm mới
                </Button>
            </Col>
        </Row>
        <Row gutter={8}>
            <Col span={24}>
                <div className="card card-primary">
                    <Row>
                        <Col span={24}>
                            <Table
                                loading={isLoadingTable}
                                locale={{ emptyText: "Không có dữ liệu" }}
                                dataSource={data.map((item: any, index) => { item.key = index; return item; }).filter((record: ChucVuDang) =>
                                    (record.ten.toLowerCase().includes(tuKhoa.toLowerCase()))
                                )}
                                rowClassName={(record, index) => {
                                    return (record?.id === idXoa) ? "selected-row row-key-" : "";
                                }}
                                pagination={{
                                    current: page,
                                    onChange: (page, pageSize) => {
                                        setPage(page);
                                    },
                                }}
                            >
                                <Column
                                    width="5%"
                                    title="STT"
                                    key="STT"
                                    render={(value, record, index) =>
                                    (
                                        <span key={"stt" + index}>
                                            {(page - 1) * searchLength + index + 1}
                                        </span>
                                    )
                                    }
                                />
                                <Column width="20%"title="Mã chức vụ Đảng" dataIndex="ma" key="ma" />
                                <Column width="60%" title="Tên chức vụ Đảng" dataIndex="ten" key="ten" />
                                <Column
                                    title=""
                                    key="action"
                                    render={(value, record, index) =>
                                    (
                                        <Space>
                                            <Button type="primary" size={"small"} title="Sửa"
                                                icon=<EditOutlined rev="" />
                                                onClick={() =>{ setFormDetailModal(value); }}
                                            >
                                                Sửa
                                            </Button>
                                            <Button type="primary" danger size={"small"} title="Xóa"
                                                onClick={() => { setIdXoa(value.id) }}
                                                icon=<DeleteOutlined rev="" />
                                            >
                                                Xóa
                                            </Button>
                                        </Space>
                                    )
                                    }
                                />
                            </Table>
                        </Col>
                    </Row>
                </div>
            </Col>
        </Row>
    </section>
    );
}
export default QuanLyChucVuDang;